module.exports = __webpack_public_path__ + "65601df8.webp";